import type { OrderProduct } from "../OrderProduct.js";

export function getSpreadProducts(products: OrderProduct[], randomUUID: () => string): OrderProduct[] {
	const spreadProducts: OrderProduct[] = [];

	for (const orderProduct of products) {
		if (!orderProduct.product.producedOnePieceAtATime || orderProduct.quantity === 1) {
			spreadProducts.push(orderProduct);
			continue;
		}

		for (let i = 0; i < orderProduct.quantity; i++) {
			spreadProducts.push({
				...orderProduct,
				id: i === 0 ? orderProduct.id : randomUUID(),
				quantity: 1,
			});
		}
	}

	return spreadProducts;
}
